__turbopack_context__.v({
  "scope": "hM9mMW_scope",
});
